import visit from 'unist-util-visit';
import stringify from 'nlcst-to-string';
import { TextAnalysis, TextAnalysisCategory, TextAnalysisResult } from '../SermonAnalyzer';

export default function ConsecutiveSentences() {

    let totalSentanceCount:number = 0;
    let repeatFirstWordCount:number = 0;
    let previousFirstword:string = '';

    
    return transformer
    
    function transformer(tree: any, file: any) {
        
        visit(tree, 'SentenceNode', search)
        
        function search(sentence: any) { 
            let firstword:string = stringify(sentence.children[0]);

            if(firstword === previousFirstword){
                repeatFirstWordCount++;
            };
            
            previousFirstword = firstword;

            totalSentanceCount++;
            
            return visit.SKIP;
        };

        if(totalSentanceCount === 0){
            return;
        }
        
        let consecutiveFirstWord:TextAnalysis = getConsecutiveSentenceText(Math.round((repeatFirstWordCount / totalSentanceCount) * 100));
    
        if(consecutiveFirstWord.result === TextAnalysisResult.improvement){
            file.improvements.push(consecutiveFirstWord);
        } else { 
            file.goodResults.push(consecutiveFirstWord);
        };
    };

    function getConsecutiveSentenceText(percentage:number) {
        let result:TextAnalysis = {title: TextAnalysisCategory.consecutive_sentences, displayText: "", helperText: "Percentage based on number of complete sentences that have the same beginning word as the previous sentence"};
        if (percentage >= 25) {
            result.displayText = `Hmm, it seems like ${percentage}% of your sentences begin with the same word. This may not be an issue, but consider changing things up to create diversity.`
            result.result = TextAnalysisResult.improvement;
        } else {
            result.displayText = "Great job, the sentences in your sermon are diverse and attention-grabbing.";
            result.result = TextAnalysisResult.goodResult;
        };
        return result;
    };
};



